<template>
  <i
    :class="[
      ns.b(),
      ns.is('indeterminate', indeterminate),
      ns.is('active', active),
    ]"
  >
    <span>
      <div :class="[ns.b('line1')]" />
      <div :class="[ns.b('line2')]" />
    </span>
  </i>
</template>

<script lang="ts" setup>
import { useNamespace } from '@vuesax-plus/hooks'
import { checkProps } from './check'

defineOptions({
  name: 'IconCheck',
})

defineProps(checkProps)

const ns = useNamespace('icon-check')
</script>
